/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './revokeAppPassword.defs.js'
export { main as default } from './revokeAppPassword.defs.js'
